"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.string.pad-start");
var _shopList = require("@/api/shop/shopList");
var _dishEvaluate = require("@/api/evaluate/dishEvaluate");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dishEvaluate',
  data: function data() {
    // 设置默认日期范围为近三个月
    var endDate = new Date();
    var startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    var formatDateTime = function formatDateTime(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
      // 搜索表单数据
      searchForm: {
        goodName: '',
        shopId: '',
        cityId: '',
        areaId: '',
        startDate: formatDateTime(startDate) + ' 00:00:00',
        endDate: formatDateTime(endDate) + ' 23:59:59',
        phone: '',
        hasImg: null
      },
      // 表格数据
      tableData: [],
      regionOptions: [],
      areaOptions: [],
      storeList: [],
      tableLoading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 30,
      total: 0
    };
  },
  created: function created() {
    var _this = this;
    (0, _shopList.getEffectiveCityList)().then(function (res) {
      _this.regionOptions = res.data;
    });
    (0, _shopList.getAreaList)().then(function (res) {
      _this.areaOptions = res.data;
    });
    this.getShops();
    this.loadData();
  },
  methods: {
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      this.loadData();
    },
    // 结束日期变化时自动设置为 23:59:59
    handleEndDateChange: function handleEndDateChange(val) {
      if (val) {
        var datePart = val.substring(0, 10);
        this.searchForm.endDate = datePart + ' 23:59:59';
      }
    },
    formatDate: function formatDate(date) {
      var formatB = function formatB(t) {
        return new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).format(new Date(+t)).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
      };
      return formatB(date);
    },
    // 获取用户会员卡类型
    getUserRankType: function getUserRankType(userRank) {
      var rank = parseInt(userRank) || 0;
      var rankMap = {
        1: '普卡',
        2: '银卡',
        3: '金卡',
        4: '黑金卡',
        5: '钻石卡'
      };
      return rankMap[rank] || '普通游客';
    },
    // 拼接评论图片URL
    getCommentImageUrl: function getCommentImageUrl(url) {
      if (!url) return '';
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 拼接CDN前缀
      return process.env.VUE_APP_COMMENT_IMAGE_URL + url;
    },
    handleExport: function handleExport(row) {
      var _this2 = this;
      (0, _dishEvaluate.downloadDishEvaluateList)(this.searchForm).then(function (res) {
        _this2.$message.success('导出成功，请到导出日志下载');
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    getShops: function getShops() {
      var _this3 = this;
      (0, _shopList.getStoreData)().then(function (res) {
        _this3.storeList = res.records;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this4 = this;
      this.tableLoading = true;

      // 处理参数：区域为5（全国）时传空
      var params = _objectSpread({}, this.searchForm);
      if (params.areaId === 5) {
        params.areaId = '';
      }

      // 添加分页参数
      params.page = this.currentPage;
      params.limit = this.pageSize;
      (0, _dishEvaluate.getDishEvaluateList)(params).then(function (res) {
        _this4.tableData = res.records;
        _this4.total = res.total;
        _this4.tableLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};